<template>
    <div class="model-cards" :class="{hidden: !enabled}">
        <div class="model-card"
             :title="model.name"
             :class="{'model-card--small': small}" v-for="model in models" :key="model.id"
             :style="{ backgroundImage: 'url(' + model.preview + ')' }">

            <a href="#" class="model-card__remove" v-if="removable"
               @click.prevent="remove(model)">
                <i class="fas fa-minus-circle"></i>
            </a>
        </div>

        <div class="model-card" :class="{'model-card--small': small}"
             v-for="(placeholder, placeholderIndex) in placeholders" :key="placeholderIndex">
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ModelTiles',
        props: {
            models: Array,
            small: {
                default: false,
                type: Boolean
            },
            limit: {
                default: 6,
                type: Number
            },
            enabled: {
                default: true,
                type: Boolean
            },
            removable: {
                default: false,
                type: Boolean
            }
        },
        computed: {
            placeholders () {
                return new Array(this.limit - this.models.length);
            }
        },
        methods: {
            remove (model) {
                this.models.splice(this.models.indexOf(model), 1);
            }
        }
    }
</script>